import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export type SizeType = "tiny" | "small" | "small-medium" | "medium";

@Component({
    selector: 'icon-button',
    styleUrls: ['./icon-button.component.less'],
    templateUrl: './icon-button.component.html'
})
export class IconButtonComponent {


    @Input('img') imgSrc: string;

    // @Input('color') set color(v: string) { this._color = v; }
    @Input() disabled: boolean;
    @Input() size: SizeType;
    @Input() accent: boolean;

    _color: string;

    onClick(ev: Event) {
        if (this.disabled)
            ev.stopPropagation();
    }
    ngOnInit(): void {

    }
    get color() {
        const c = this._color;
        if (this._color)
            return this._color;
        if (this.accent)
            return 'accent';
        return null;
    }
    get buttonClasses() {
        let obj: any = { 'disabled': !!this.disabled };
        if (!!this.size)
            obj[this.size] = true;
        return obj;
    }
}
